import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import welcomeimage from '../../assets/images/welcomeimage.jpg';
import check from '../../assets/images/check.svg';
import licenecheck from '../../assets/images/licenece.svg';
import whitestar from '../../assets/images/whitestar.svg';
import compassion from '../../assets/images/compassion.png';
import lightbulb from '../../assets/images/excellence.png';
import community from '../../assets/images/users-profiles.svg';
import growth from '../../assets/images/diagram.png';
import david from '../../assets/images/devid.svg';
function AboutPage() {
  return (
    <main className="about-page">
      <section className="about-banner" aria-label="About our school">
        <div className="hero-inner">
          <div className="hero-grid">
            <div className="hero-content">
              <h1 className="about-banner-title">About Our School</h1>
              <p className="about-banner-desc">
                Discover our mission, and the dedicated team behind The David Foster Preschool & Afterschool Academy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-second">
        <div className="about-inner">
          {/* Mission & Vision cards */}
          <div className="about-cards">
            <article className="about-card about-card-mission">
              <span className="about-card-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
                  <circle cx="12" cy="12" r="5.5" stroke="currentColor" strokeWidth="1.8" />
                  <circle cx="12" cy="12" r="2" fill="currentColor" />
                </svg>
              </span>
              <h2 className="about-card-title">Our Mission</h2>
              <p className="about-card-text">
                To create a nurturing learning environment that supports every child&apos;s academic, emotional, and social growth. We believe in empowering young minds through play-based learning and individualized attention.
              </p>
            </article>
            <article className="about-card about-card-vision">
              <span className="about-card-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5C7.5 5 4 8 3 12c1 4 4.5 7 9 7s8-3 9-7c-1-4-4.5-7-9-7z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
                </svg>
              </span>
              <h2 className="about-card-title">Our Vision</h2>
              <p className="about-card-text">
                Raising confident, curious, and compassionate learners who are prepared for lifelong success. We envision a world where every child has access to quality early education that sparks their love of learning.
              </p>
            </article>
          </div>

          {/* Our Story */}
          <div className="about-story">
            <div className="about-story-content">
              <p className="about-story-eyebrow">Our Story</p>
              <h2 className="about-story-title">A Legacy of Excellence Since 1992</h2>
              <p className="about-story-p">
                Our story began in 1992 when the founder started teaching in Brooklyn, inspired by early exposure to daycare through family involvement. What started as a calling to nurture young minds grew into a licensed childcare program serving 12 children.
              </p>
              <p className="about-story-p">
                In 1997, a storefront location at 580 Rogers Avenue was acquired and licensed, expanding the school&apos;s reach to more families in the community. By 2014, the academy moved to its current home at 72 Clarkson Avenue, fully licensed by the Department of Health & Mental Hygiene, Buildings Department, and Fire Department.
              </p>
              <p className="about-story-p">
                The school was awarded the Universal PRE-K after completing its Birth-to-Five proposal, and continued to serve families through the pandemic with virtual learning support — always putting children and families first.
              </p>
            </div>
            <div className="about-story-image-wrap">
              <img src={welcomeimage} alt="The David Foster Preschool & Afterschool Academy" className="about-story-image" />
            </div>
          </div>
        </div>
      </section>

      {/* In Honor of David Augustus Foster */}
      <section className="about-tribute" aria-label="In honor of David Augustus Foster">
        <div className="about-tribute-inner">
          <div className="about-tribute-box">
            <span className="about-tribute-icon" aria-hidden="true">
            <img src={david} alt="david" />
            </span>
            <h2 className="about-tribute-title">In Honor of David Augustus Foster</h2>
            <p className="about-tribute-intro">
              The academy is named in honor of David Augustus Foster, whose belief that
            </p>
            <blockquote className="about-tribute-quote">
              &quot;Education is the key to success — the sky is the limit.&quot;
            </blockquote>
            <p className="about-tribute-outro">
              His words continue to inspire the school&apos;s mission and guide every decision we make in service of our children and families.
            </p>
          </div>
        </div>
      </section>

      {/* Licensing & Compliance / Staff Credentials */}
      <section className="about-compliance" aria-label="Licensing and staff credentials">
        <div className="about-compliance-bg" aria-hidden="true" />
        <div className="about-compliance-overlay" aria-hidden="true" />
        <div className="about-compliance-inner">
          <div className="about-compliance-col">
            <h2 className="about-compliance-title">
              <span className="about-compliance-title-icon" aria-hidden="true">
              <img src={licenecheck} alt="licenecheck" />
              </span>
              Licensing & Compliance
            </h2>
            <ul className="about-compliance-list">
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                  <img src={check} alt="check" />
                </span>
                NYC Department of Health & Mental Hygiene
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                New York City Department of Education
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                New York City Department of Buildings
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                New York City Fire Department
              </li>
            </ul>
          </div>
          <div className="about-compliance-col">
            <h2 className="about-compliance-title">
              <span className="about-compliance-title-icon" aria-hidden="true">
              <img src={whitestar} alt="whitestar" />
              </span>
              Staff Credentials
            </h2>
            <ul className="about-compliance-list">
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                Certified early childhood educators
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                CPR & First Aid trained
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                Early childhood development specialists
              </li>
              <li>
                <span className="about-compliance-check" aria-hidden="true">
                <img src={check} alt="check" />
                </span>
                Background-checked & fingerprinted
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Values - Fifth section */}
      <section className="about-values" aria-label="Our values">
        <div className="about-values-inner">
          <p className="about-values-eyebrow">Our Values</p>
          <h2 className="about-values-title">What We Stand For</h2>
          <div className="about-values-grid">
            <article className="about-value-card">
              <span className="about-value-icon" aria-hidden="true">
              <img src={compassion} alt="compassion" />
              </span>
              <h3 className="about-value-heading">Compassion</h3>
              <p className="about-value-desc">We nurture each child with warmth, understanding, and genuine care.</p>
            </article>
            <article className="about-value-card">
              <span className="about-value-icon" aria-hidden="true">
              <img src={lightbulb} alt="excellence" />
              </span>
              <h3 className="about-value-heading">Excellence</h3>
              <p className="about-value-desc">We strive for the highest standards in early childhood education.</p>
            </article>
            <article className="about-value-card">
              <span className="about-value-icon" aria-hidden="true">
              <img src={community} alt="community" />
              </span>
              <h3 className="about-value-heading">Community</h3>
              <p className="about-value-desc">We build strong partnerships between the community, families, teachers, and children.</p>
            </article>
            <article className="about-value-card">
              <span className="about-value-icon" aria-hidden="true">
              <img src={growth} alt="growth" />
              </span>
              <h3 className="about-value-heading">Growth</h3>
              <p className="about-value-desc">We foster continuous learning and development in every child.</p>
            </article>
          </div>
        </div>
      </section>

      {/* Our Team - Sixth section */}
      <section className="about-team" aria-label="Our team">
        <div className="about-team-inner">
          <p className="about-team-eyebrow">Our Team</p>
          <h2 className="about-team-title">Meet Our Educators</h2>
          <p className="about-team-desc">
            Our certified educators are passionate about early childhood development and dedicated to helping every child reach their full potential.
          </p>
          <div className="about-team-grid">
            {[
              { name: 'Maria Santos', role: 'Toddler Program Lead', certs: 'M.Ed, CPR Certified', img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop' },
              { name: 'James Chen', role: 'Preschool Lead Teacher', certs: 'M.Ed, Early Childhood Certified', img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop' },
              { name: 'Sarah Williams', role: 'Afterschool Director', certs: 'M.S. Ed, First Aid Certified', img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop' },
              { name: 'David Foster', role: 'Lead Educator', certs: 'B.Ed, CPR Certified', img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop' },
            ].map((person, idx) => (
              <article key={idx} className="about-team-card">
                <div className="about-team-card-image-wrap">
                  <img src={person.img} alt="" className="about-team-card-image" />
                </div>
                <h3 className="about-team-card-name">{person.name}</h3>
                <p className="about-team-card-role">{person.role}</p>
                <p className="about-team-card-certs">{person.certs}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

         {/* CTA */}
         <section className="cta" id="schedule-tour">
        <div className="cta-inner">
          <h2 className="cta-title">Join Our Preschool & Afterschool Family</h2>
          <p className="cta-desc">Give your child the best beginning they deserve. Schedule a tour today and see why families love The David Foster Preschool & Afterschool Academy.</p>
          <div className="cta-actions">
            <Link to={{ pathname: '/admissions', hash: 'schedule-tour' }} className="btn btn-primary cta-primary">
              <span className="btn-icon" aria-hidden="true">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="3"
                    y="4"
                    width="14"
                    height="13"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                  <path d="M3 8H17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M8 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M12 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <rect x="7" y="10" width="2.2" height="2.2" rx="0.4" fill="currentColor" />
                </svg>
              </span>
              Schedule Tour
            </Link>
            <Link to="/contact" className="btn btn-outline cta-secondary">
              Inquiry Now
            </Link>
          </div>

          <div className="cta-meta" aria-label="Contact and hours">
            <a className="cta-meta-item" href="tel:718-462-0776">
              <span className="cta-meta-icon" aria-hidden="true">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 3.5L9.2 7.2C9.4 7.7 9.3 8.3 8.9 8.7L7.6 10C9 12.7 11.3 15 14 16.4L15.3 15.1C15.7 14.7 16.3 14.6 16.8 14.8L20.5 16.5C21.1 16.8 21.3 17.4 21.1 18C20.6 19.5 19.2 20.5 17.6 20.5C10.1 20.5 3.5 13.9 3.5 6.4C3.5 4.8 4.5 3.4 6 2.9C6.6 2.7 7.2 2.9 7.5 3.5Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="cta-meta-text">718-462-0776</span>
            </a>

            <div className="cta-meta-item">
              <span className="cta-meta-icon" aria-hidden="true">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 8V12L14.5 13.5"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                </svg>
              </span>
              <span className="cta-meta-text">Monday - Friday: 8:00 AM - 7:00 PM</span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AboutPage;
